import { jsx as _jsx } from "react/jsx-runtime";
export default function VerticalAxisLine(props) {
    const { plotHeight, style } = props;
    return _jsx("line", { y1: 0, y2: plotHeight, stroke: "black", style: style });
}
//# sourceMappingURL=VerticalAxisLine.js.map